<template>
  <div class="pb-9">
    <div class="text-center mt-16 mb-16" dir="auto">
     <about-title :title="$t('production-lines')" page-route=""/>
    </div>
    <div class="w-80 ma-auto d-flex flex-column flex-xl-row flex-lg-row">
      <v-card width="800" height="300" class="mx-4 card-hover mb-5" v-for="(item,i) in production_lines" :key="i">
        <img :src="item.file" style="width:80px" alt="">        <h4 class="font-weight-bold card-title py-6">{{ item.title }}</h4>
        <p class="px-5 py-3 card-detail">{{ item.details }}</p>
      </v-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import AboutTitle from "../../material/pages/About/Components/AboutTitle";
export default {
  name: 'mainGlassProductionLines',
  components: {AboutTitle},
  computed: {
    ...mapState({
      production_lines: state => state.glassManagement.production_lines,
    })
  },
  created() {
    this.$store.dispatch('glassManagement/getGlassProductionLines');
  },
  data() {
    return {
      features: [
        {
          title: 'بزرگترین خط تولید شیشه',
          details: 'بزرگترین خط تولید شیشه فلوت در خاورمیانه با ظرفیت 250.000 تن شیشه قابل فروش در سال',
          icon: 'mdi-hammer'
        },
        {
          title: 'محدوده تولید',
          details: 'بهره مندی از تکنولوژی فلوت عریض با پهنای ریبون 5.3 متر\n' +
              'باز بودن محدوده ضخامت از 1.8 میلی متر تا 19 میلی متر\n' +
              'تولید شیشه سوپرکلیر در سایز های مختلف از 1.22*1.83 متر تا 4.88*7.20 متر\n' +
              'تولید شیشه جامبو 3.21*6 متر و سوپرجامبو 4.88 *7.2 متر',
          icon: 'mdi-fire'
        },
        {
          title: 'تکنولوژی و توانمندی',
          details: 'عیب یابی آنلاین و حذف شیشه های معیوب و تضمین کیفیت شیشه ها\n' +
              'صادر کننده برتر طی 4 سال متوالی',
          icon: 'mdi-account-tie-voice'
        },
      ]
    }
  }
}
</script>
<style scoped>
.card-hover:hover > i {
  color: #25458c !important;
}
.card-hover{
  text-align: center;
}
.card-hover:hover{
  padding-right: 15px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;;
}
.card-hover:hover>i{
  font-size: 50px !important;
}
.card-detail {
  opacity: 0;
}
.card-hover:hover > .card-detail {
  opacity: 1;
  transition: opacity .7s;
}
</style>